import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StripeCheckout } from './interfaces/stripe-checkout.interface';

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  private _httpClient = inject(HttpClient);

  createCheckoutSession(data: StripeCheckout): Observable<any> {
    return this._httpClient.post(
      `${environment.apiUrl}/stripe/create-initial-checkout-session`,
      data
    );
  }

  createCustomerPortalSession(): Observable<{ url: string }> {
    return this._httpClient.get<{ url: string }>(
      `${environment.apiUrl}/stripe/create-customer-portal-session`
    );
  }

  renewSubscriptionCheckout(planId: string, capAmount?: number): Observable<{ url: string }> {
    return this._httpClient.post<{ url: string }>(
      `${environment.apiUrl}/stripe/renew-subscription-checkout`,
      { planId, capAmount }
    );
  }

  historicalImportCheckout(planId: string): Observable<{
    url: string;
    // Count of orders backfilled FOR FREE after payment (disclosure only; the
    // historical import is never charged). (dashboardly-yvs9j)
    orderCount: number;
  }> {
    return this._httpClient.post<{
      url: string;
      orderCount: number;
    }>(`${environment.apiUrl}/stripe/historical-import-checkout`, { planId });
  }

  /**
   * Create recovery checkout for users who didn't complete registration
   * Supports 14-day trial for eligible users
   */
  createRecoveryCheckout(
    planId: string,
    includeTrial = false,
    betaInviteToken?: string,
    promotekitReferral?: string
  ): Observable<{ checkoutUrl: string }> {
    return this._httpClient.post<{ checkoutUrl: string }>(
      `${environment.apiUrl}/stripe/recovery-checkout`,
      { planId, includeTrial, betaInviteToken, promotekitReferral }
    );
  }
}
